module.exports = deprecate;
var loggedMessages = {};

function deprecate(message) {
  if (loggedMessages[message]) {
    return;
  }

  console.warn("DEPRECATED (@octokit/rest): ".concat(message));
  loggedMessages[message] = 1;
}